import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions'
import _ from 'lodash';
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    errorText: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
        color: 'red'
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
});

class InstructorForm extends Component {
    state = {}

    handleTabChange = (event, value) => {
        this.setState({ majorTabValue: value });
    };

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        const validator = {
            field_name, value
        }

        // if (field_name === 'Email') {
        //     _.debounce((validator) => this.props.runValidator(validator), 500)
        //     this.props.updateInstructorForm(update_data);
        // }
        // else {
            this.props.runValidator(validator)
            this.props.updateInstructorForm(update_data);
        // }
    }

    render() {
        const { classes, view_type, theme, instructor, validator } = this.props;

        const passwordCreate = (prop) => {
            if (prop) {
                return (
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="Password"
                            label="Password"
                            className={classes.textField}
                            value={instructor.Password}
                            onChange={this.handleChange('Password')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'Password'))}
                            error={instructor.Password != instructor.PasswordConfirm || validator.filter(v => v.field_name === 'Password')[0].error}
                            helperText={validator.filter(v => v.field_name === 'Password')[0].error_msg}
                        />
                        <TextField
                            required
                            id="PasswordConfirm"
                            label="Password Confirm"
                            className={classes.textField}
                            value={instructor.PasswordConfirm}
                            onChange={this.handleChange('PasswordConfirm')}
                            margin="normal"
                            variant="outlined"
                            type="password"
                            error={instructor.Password != instructor.PasswordConfirm || validator.filter(v => v.field_name === 'PasswordConfirm')[0].error}
                            // error={this.fieldHasError(validator.filter(v => v.field_name === 'PasswordConfirm'))}
                            helperText={"Must match the 'Password' field"}
                        />
                    </Grid>
                )
            }
        }

        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="FirstName"
                                    label="First Name"
                                    onChange={this.handleChange('FirstName')}
                                    value={instructor.FirstName}
                                    error={validator.filter(v => v.field_name === 'FirstName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'FirstName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="LastName"
                                    label="Last Name"
                                    value={instructor.LastName}
                                    onChange={this.handleChange('LastName')}
                                    error={validator.filter(v => v.field_name === 'LastName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'LastName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Address"
                                    label="Address"
                                    value={instructor.Address}
                                    onChange={this.handleChange('Address')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="City"
                                    label="City"
                                    value={instructor.City}
                                    onChange={this.handleChange('City')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="State"
                                    label="State"
                                    value={instructor.State}
                                    onChange={this.handleChange('State')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Zip"
                                    label="Zip"
                                    value={instructor.Zip}
                                    onChange={this.handleChange('Zip')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Phone"
                                    label="Phone"
                                    value={instructor.Phone}
                                    onChange={this.handleChange('Phone')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Email"
                                    label="Email"
                                    value={instructor.Email}
                                    onChange={this.handleChange('Email')}
                                    error={validator.filter(v => v.field_name === 'Email')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'Email')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            {passwordCreate(this.props.view_type === 'create')}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '10px' }}
                                            checked={(instructor.Active === 1 || instructor.Active === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                            name="Active"
                                        />
                                    }
                                    label="Active"
                                />
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={6}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                    </Grid>
                </Grid>

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructor: Actions.getInstructor,
        deleteInstructor: Actions.deleteInstructor,
        saveInstructor: Actions.saveInstructor,
        updateInstructorForm: Actions.updateInstructorForm,
        toggleCompany: Actions.toggleCompany,
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ instructorApp, validator }) {
    return {
        instructor: instructorApp.instructors.currentInstructor,
        validator: validator.list,
        editInfo: instructorApp.instructors.editInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorForm)));



// WEBPACK FOOTER //
// src/main/content/instructor/InstructorForm.js